import React, { useEffect, useState } from "react";
import { CircularProgress, Typography, Box } from "@mui/material";
import { Helmet } from "react-helmet";
import { Currency, PageTitle } from "../components/common";
import "./ViewAccount.css";
import fetchData from "../../service/shared/viewAccount";
import { useSelector } from "react-redux";

const ViewAccount = ({ data }) => {
  const [accountData, setAccountData] = useState(null);
  const Currency = useSelector((state) => state.curr);
  const formatNumber = (number) => {
    return parseFloat(number).toLocaleString("en-IN");
  };

  useEffect(() => {
    const fetchAccountData = async () => {
      try {
        const response = await fetchData();
        setAccountData(response);
      } catch (error) {
        console.error("Error fetching account data:", error);
      }
    };

    fetchAccountData();
  }, []);

  // const formatNumber = (number) => {
  //     return number.toLocaleString();
  // };

  const companyName = {
    companyName: "Your Company",
  };

  const t = (str) => str; // Placeholder function for translation
  let totalAccumulatedIncome = 0;
  let totalWithdrawable = 0;

  if (accountData) {
    accountData.data.result.forEach((item) => {
      totalAccumulatedIncome += parseFloat(item.accumulated_income);
      totalWithdrawable += parseFloat(item.remaining_income);
    });
  }

  return (
    <div>
      <React.Suspense fallback={<CircularProgress />}>
        <Helmet>
          <title>
            {companyName.companyName} | {t("Sidemenu.viewAccount")}
          </title>
        </Helmet>

        <PageTitle title="myAccount" />
        <br />
        <br />

        <Box className="tile">
          <div className="tableWrapper">
            <table className="table">
              {/* Table Header */}
              <thead>
                {/* Header Rows */}
                <tr>
                  <th></th>
                  <th></th>
                  <th>
                    <h6 className="buv">BUVStat</h6>
                  </th>
                  <th></th>
                  <th>
                    <h6 className="ilp">I-Lifestyle Points</h6>
                  </th>
                  <th></th>
                  <th>
                    <h6 className="income">Income</h6>
                  </th>
                  <th></th>
                </tr>
                <tr className="tableRow">
                  <th>
                    <h6 className="smallFont">Username</h6>
                  </th>
                  <th>
                    <h6 className="smallFont">Rank</h6>
                  </th>
                  <th>
                    <h6 className="smallFont">Left</h6>
                  </th>
                  <th>
                    <h6 className="smallFont">Right</h6>
                  </th>
                  <th>
                    <h6 className="smallFont">Accumulated</h6>
                  </th>
                  <th>
                    <h6 className="smallFont">Remaining</h6>
                  </th>
                  <th>
                    <h6 className="smallFont">Accumulated</h6>
                  </th>
                  <th>
                    <h6 className="smallFont">Withdrawable</h6>
                  </th>
                </tr>
              </thead>
              {/* Table Body */}
              <tbody>
                {/* Map over the accountData array to render rows dynamically */}
                {accountData &&
                  accountData.data.result.map((item) => (
                    <tr className="tableRow" key={item.id}>
                      <td>
                        <h6 className="datasmallFont">{item.username}</h6>
                      </td>
                      <td>
                        <h6 className="datasmallFont">{item.rank}</h6>
                      </td>
                      <td>
                        <h6 className="datasmallFont">
                          {formatNumber(item.left)}
                        </h6>
                      </td>
                      <td>
                        <h6 className="datasmallFont">
                          {formatNumber(item.right)}
                        </h6>
                      </td>
                      <td>
                        <h6 className="datasmallFont">
                          {formatNumber(item.accumulated_lifestyle)}
                        </h6>
                      </td>
                      <td>
                        <h6 className="datasmallFont">
                          {formatNumber(item.remaining_lifestyle)}
                        </h6>
                      </td>
                      <td>
                        <h6 className="datasmallFont">
                          {Currency.currentCurr}{" "}
                          {formatNumber(
                            parseFloat(item.accumulated_income).toFixed(2)
                          )}
                        </h6>
                      </td>
                      <td>
                        <h6 className="smallFont">
                          {Currency.currentCurr}{" "}
                          {formatNumber(
                            parseFloat(item.remaining_income).toFixed(2)
                          )}
                        </h6>
                      </td>
                    </tr>
                  ))}
                <tr className="tableRow">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <h6
                      style={{ fontWeight: "bold" }}
                      className="datasmallFont"
                    >
                      {Currency.currentCurr}{" "}
                      {formatNumber(totalAccumulatedIncome.toFixed(2))}
                    </h6>
                  </td>
                  <td>
                    <h6 style={{ fontWeight: "bold" }} className="smallFont">
                      {Currency.currentCurr}{" "}
                      {formatNumber(totalWithdrawable.toFixed(2))}
                    </h6>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Box>
      </React.Suspense>
    </div>
  );
};

export default ViewAccount;
